module.exports = __webpack_public_path__ + "img/es.5263e3aa.png";